import React from 'react';
import { useCommissionPlansList } from '../hooks/use-commission-plans-list.js';
import CommissionPlansPageView from './commission-plans-page-view.jsx';

function CommissionPlansPageContainer() {
  const state = useCommissionPlansList();
  return <CommissionPlansPageView {...state} />;
}

export default CommissionPlansPageContainer;
